import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AgGridModule } from 'ag-grid-angular';

import { AvatarComponent } from './components/avatar/avatar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CheckboxFilterComponent } from './components/checkbox-filter/checkbox-filter.component';
import { ColumnFilterComponent } from './components/column-filter/column-filter.component';
import { FooterComponent } from './components/footer/footer.component';
import { GridListComponent } from './components/grid-list/grid-list.component';
import { HistoryComponent } from './components/history/history.component';
import { InputColumnFilterComponent } from './components/input-column-filter/input-column-filter.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalQuestionComponent } from './components/modal-question/modal-question.component';
import { ModalComponent } from './components/modal/modal.component';
import { QuestionComponent } from './components/modals/question/question.component';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { SnackBarService } from './components/snack-bar/snack-bar.service';
import { MenuComponent } from './containers/menu/menu.component';
import { SidebarComponent } from './containers/sidebar/sidebar.component';
import { InputPatternDirective } from './directives/input-pattern.directive';
import { VisibleToRoleDirective } from './directives/visible-to-role.directive';
import { CardComponent } from './components/card/card.component';
import { HtmlPipe } from './pipes/html.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { LogPipe } from './pipes/log.pipe';
import { effects } from './store/effects';
import * as fromShared from './store/reducers';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { SessionModalComponent } from './components/modals/session-modal/session-modal.component';
import { TransformMilisecondsPipe } from './pipes/transform-miliseconds.pipe';
import { GridArmCertificateListComponent } from './components/grid-arm-certificate-list/grid-arm-certificate-list.component';
import { ModalExpiredDateComponent } from '../certificates/components/modal-expired-date/expired-date.component';

@NgModule({
  declarations: [
    MenuComponent,
    AvatarComponent,
    SidebarComponent,
    SidebarItemComponent,
    BreadcrumbComponent,
    HistoryComponent,
    ModalComponent,
    LogPipe,
    KeysPipe,
    VisibleToRoleDirective,
    HtmlPipe,
    SnackBarComponent,
    FooterComponent,
    GridListComponent,
    CheckboxFilterComponent,
    InputColumnFilterComponent,
    ColumnFilterComponent,
    LoaderComponent,
    ModalQuestionComponent,
    QuestionComponent,
    CardHeaderComponent,
    CardComponent,
    InputPatternDirective,
    SessionModalComponent,
    TransformMilisecondsPipe,
    GridArmCertificateListComponent,
    ModalExpiredDateComponent
  ],
  entryComponents: [
    CheckboxFilterComponent,
    InputColumnFilterComponent,
    LoaderComponent,
    SessionModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    StoreModule.forFeature(fromShared.sharedFeatureKey, fromShared.reducers, {
      metaReducers: fromShared.metaReducers
    }),
    EffectsModule.forFeature(effects),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([
      CheckboxFilterComponent,
      InputColumnFilterComponent
    ]),
    TranslateModule
  ],
  exports: [
    MenuComponent,
    SidebarComponent,
    BreadcrumbComponent,
    HistoryComponent,
    ModalComponent,
    LogPipe,
    KeysPipe,
    VisibleToRoleDirective,
    HtmlPipe,
    FooterComponent,
    SnackBarComponent,
    GridListComponent,
    ColumnFilterComponent,
    LoaderComponent,
    ModalQuestionComponent,
    QuestionComponent,
    InputPatternDirective,
    TranslateModule,
    CardComponent,
    CardHeaderComponent,
    GridArmCertificateListComponent
  ],
  providers: [SnackBarService, DatePipe]
})
export class SharedModule {}
